import React from 'react';
import { Section } from './ui/Section';
export function Bonuses() {
  const bonuses = [{
    code: 'B1',
    title: 'Mapa de Sustitución 1:1',
    desc: 'Cambia esto por esto. La guía visual para reemplazar cualquier ingrediente con gluten en 30 segundos.',
    value: '19',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e564f364-bcf6-44ea-9d57-8019182cc2f4.jpg'
  }, {
    code: 'B2',
    title: 'Ruta de Compra Sin Harinas',
    desc: 'Qué comprar en Mercadona, Lidl y Carrefour. Los 30 productos trampa que sabotean el proceso.',
    value: '15',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/75052641-1d3a-48a3-a1cb-6c6898250b25.jpg'
  }, {
    code: 'B3',
    title: 'Planificador 7x3',
    desc: '21 comidas resueltas. El sistema semanal para no improvisar nunca con hambre ni cansancio.',
    value: '27',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3daae46a-0af3-431f-a6d5-2e7a7690d783.jpg'
  }, {
    code: 'B4',
    title: 'Kit SOS Antojos',
    desc: '20 rescates en menos de 10 minutos y los scripts mentales para los momentos más difíciles.',
    value: '19',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e10cc375-cb90-40df-9743-92e3b5e8d592.jpg'
  }, {
    code: 'B5',
    title: 'Guía Social Sin Gluten',
    desc: 'Come fuera sin dar explicaciones. Protocolos para bares, bodas y Navidad en España.',
    value: '29',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/e136b625-03c6-466a-8cbd-6c311ca2b766.jpg'
  }, {
    code: 'B6',
    title: 'Tracker de Desinflamación',
    desc: 'Mide tu cambio en 21 días. La evidencia visual del progreso que mantiene la motivación.',
    value: '15',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47ee0c80-5b36-4ef7-96c1-f08042f4bd58.jpg'
  }];
  return <Section variant="alt" data-id="element-47" data-mp="noq5gtsxfkyo">
      <div className="text-center mb-4" data-id="element-48" data-mp="ns4ak9sz689t">
        <span className="inline-block bg-brand-secondaryLight text-brand-secondaryHover font-semibold text-xs uppercase tracking-wider rounded-full px-4 py-1.5" data-id="element-49" data-mp="irgdb6e5kv75">
          Incluido gratis
        </span>
      </div>
      <h2 className="font-display text-2xl md:text-4xl font-bold text-center mb-4 text-brand-title" data-id="element-50" data-mp="3hgybfdy6fow7">
        6 Bonos Exclusivos de Implementación
      </h2>
      <p className="text-center text-brand-textMuted mb-10 font-body max-w-xl mx-auto text-sm md:text-base" data-id="element-51" data-mp="3qipdm8tiddlb">
        Las herramientas que hacen que el sistema funcione en tu vida real
        desde el día 1.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-52" data-mp="2xtig9d5siu1n">
        {bonuses.map((bonus, i) => <div key={i} className="bg-white border border-brand-border rounded-2xl overflow-hidden shadow-card" data-id="element-53" data-mp="32sv15sd3pr1l" data-mpi={i}>
            <div className="relative aspect-[4/3] overflow-hidden" data-id="element-54" data-mp="37kv65z813a51">
              <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover" loading="lazy" data-id="element-55" data-mp="2a4pkbgp64m71" />
              <div className="absolute top-3 left-3 w-8 h-8 rounded-full bg-white/90 text-brand-primary font-heading font-bold flex items-center justify-center text-xs shadow-card" data-id="element-56" data-mp="2f30u5rfgqwp9">
                {bonus.code}
              </div>
            </div>
            <div className="p-5" data-id="element-57" data-mp="22lpw8xqri6hc">
              <div className="flex items-start justify-between gap-2 mb-1.5" data-id="element-58" data-mp="1xlk29ax0s7w3">
                <h3 className="font-heading text-base font-bold text-brand-title" data-id="element-59" data-mp="1xnogalomuna3">
                  {bonus.title}
                </h3>
                <span className="shrink-0 bg-brand-secondaryLight text-brand-secondaryHover font-heading font-bold text-[11px] rounded-full px-2.5 py-1 whitespace-nowrap" data-id="element-60" data-mp="1olf6xz53ozya">
                  Valor: €{bonus.value}
                </span>
              </div>
              <p className="font-body text-brand-textMuted text-sm leading-relaxed" data-id="element-61" data-mp="1et9hox68gwms">
                {bonus.desc}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}